import { render, staticRenderFns } from "./item-menu-lateral.html?vue&type=template&id=0673da88&scoped=true&"
import script from "./item-menu-lateral.js?vue&type=script&lang=js&"
export * from "./item-menu-lateral.js?vue&type=script&lang=js&"
import style0 from "./item-menu-lateral.css?vue&type=style&index=0&id=0673da88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673da88",
  null
  
)

export default component.exports